<template>
  <section class="catalogs">
    <div class="manualsCatalogs">
      <h2>Catálogos, Manuais, Relatórios, Certificados etc</h2>

      <div class="manualsCatalogs__tab">
        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisAgratto')"
        >
          Arquivos Agratto
        </button>
        <div class="manualsCatalogs__tabcontent" id="manuaisAgratto">
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Categoria</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Catalogo-Agratto-Aspirador-de-Po.pdf</td>
                <td>Catálogo</td>
                <td>Aspirador de Pó</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Catalogo-Agratto-Aspirador-de-Po.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Catalogo-Agratto-Split-2020.pdf</td>
                <td>Catálogo</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Catalogo-Agratto-Split-2020.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Catalogo-HW-Convencional-Agratto-Confort-Fit.pdf</td>
                <td>Catálogo</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Catalogo-HW-Convencional-Agratto-Confort-Fit.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Catalogo-HW-Convencional-Agratto-ECO.pdf</td>
                <td>Catálogo</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Catalogo-HW-Convencional-Agratto-ECO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Catalogo-HW-Convencional-Agratto-FIT-TOP.pdf</td>
                <td>Catálogo</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Catalogo-HW-Convencional-Agratto-FIT-TOP.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Catalogo-HW-Inverter-Agratto-BIO.pdf</td>
                <td>Catálogo</td>
                <td>Split Inverter</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Catalogo-HW-Inverter-Agratto-BIO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Catalogo-HW-Inverter-Agratto-NEO.pdf</td>
                <td>Catálogo</td>
                <td>Split Inverter</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Catalogo-HW-Inverter-Agratto-NEO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Catalogo-HW-Inverter-Agratto-Neo-Top.pdf.pdf</td>
                <td>Catálogo</td>
                <td>Split Inverter</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Catalogo-HW-Inverter-Agratto-Neo-Top.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-Aspirador-de-Po.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Aspirador de Pó</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-Aspirador-de-Po.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-Cortina-de-Ar.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Cortina de Ar</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-Cortina-de-Ar.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-BIO.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-BIO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-Confort-Fit.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-Confort-Fit.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-ECO</td>
                <td>Certificado de Garantia</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-ECO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-FIT-TOP.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-FIT-TOP.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-NEO.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-NEO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>

              <tr>
                <td>Certificado-De-Garantia-Agratto-ECO-Inverter.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Split Inverter</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-ECO-Inverter.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-ECO-TOP-Inverter.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Split Inverter</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-ECO-TOP-Inverter.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>

              <tr>
                <td>Certificado-De-Garantia-Agratto-Panela-Eletrica.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Panela Elétrica</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-Panela-Eletrica.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-Piso-Teto.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Piso Teto</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-Piso-Teto.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Certificado-De-Garantia-Agratto-Portatil.pdf</td>
                <td>Certificado de Garantia</td>
                <td>Ar Portátil</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Certificado-De-Garantia-Agratto-Portatil.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-De-Instrucoes-Agratto-Confort-Fit.pdf</td>
                <td>Manual de Instruções</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Agratto-Confort-Fit.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-De-Instrucoes-Uso-Instalacao-Agratto-BIO.pdf</td>
                <td>Manual de Instruções</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Uso-Instalacao-Agratto-BIO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-De-Instrucoes-Uso-Instalacao-Agratto-ECO.pdf</td>
                <td>Manual de Instruções</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Uso-Instalacao-Agratto-ECO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-De-Instrucoes-Uso-Instalacao-Agratto-FIT-TOP.pdf</td>
                <td>Manual de Instruções</td>
                <td>Split Convencional</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Uso-Instalacao-Agratto-FIT-TOP.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-De-Instrucoes-Agratto-ECO-Inverter.pdf</td>
                <td>Manual de Instruções</td>
                <td>Split Inverter</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Agratto-ECO-Inverter.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-De-Instrucoes-Agratto-ECO-TOP-Inverter.pdf</td>
                <td>Manual de Instruções</td>
                <td>Split Inverter</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Agratto-ECO-TOP-Inverter.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>

              <tr>
                <td>Manual-De-Instrucoes-Uso-Instalacao-Agratto-NEO.pdf</td>
                <td>Manual de Instruções</td>
                <td>Split Inverter</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Uso-Instalacao-Agratto-NEO.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>
                  Manual-De-Instrucoes-Uso-Instalacao-Agratto-Piso-Teto.pdf
                </td>
                <td>Manual de Instruções</td>
                <td>Piso Teto</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Uso-Instalacao-Agratto-Piso-Teto.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>
                  Manual-De-Instrucoes-Uso-Instalacao-Agratto-Portatil.pdf
                </td>
                <td>Manual de Instruções</td>
                <td>Ar Portátil</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-De-Instrucoes-Uso-Instalacao-Agratto-Portatil.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-Do-Usuário-Agratto-Cortina-de-Ar.pdf</td>
                <td>Manual do Usuário</td>
                <td>Cortina de Ar</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-Do-Usuário-Agratto-Cortina-de-Ar.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-Do-Usuario-Aspirador-de-Po-Agratto.pdf</td>
                <td>Manual do Usuário</td>
                <td>Aspirador de Pó</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-Do-Usuario-Aspirador-de-Po-Agratto.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-Do-Usuario-Panela-Eletrica-PAIX-Agratto.pdf</td>
                <td>Manual do Usuário</td>
                <td>Panela Elétrica</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-Do-Usuario-Panela-Eletrica-PAIX-Agratto.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
              <tr>
                <td>Manual-Do-Usuario-Panela-Pressao-Agratto-PE-PED.pdf</td>
                <td>Manual do Usuário</td>
                <td>Panela de Pressão</td>
                <td>Agratto</td>
                <td>
                  <a
                    target="_blank"
                    rel="noopener"
                    href="https://www.leverosintegra.com.br/download/manuais/Agratto/Manual-Do-Usuario-Panela-Pressao-Agratto-PE-PED.pdf"
                    >Visualizar</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisCarrier')"
        >
          Arquivos Carrier
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisCarrier"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td>
                  <a target="_blank" rel="noopener" href="">Visualizar</a>
                </td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisComfee')"
        >
          Arquivos Comfee
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisComfee"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisDaikin')"
        >
          Arquivos Daikin
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisDaikin"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisDelonghi')"
        >
          Arquivos Delonghi
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisDelonghi"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisElgin')"
        >
          Arquivos Elgin
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisElgin"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisFujitsu')"
        >
          Arquivos Fujitsu
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisFujitsu"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisGree')"
        >
          Arquivos Gree
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisGree"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisIBBL')"
        >
          Arquivos IBBL
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisIBBL"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisLG')"
        >
          Arquivos LG
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisLG"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisLorenzetti')"
        >
          Arquivos Lorenzetti
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisLorenzetti"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisMaxiflex')"
        >
          Arquivos Maxiflex
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisMaxiflex"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisMidea')"
        >
          Arquivos Midea
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisMidea"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisSpringerMidea')"
        >
          Arquivos Springer Midea
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisSpringerMidea"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisTCL')"
        >
          Arquivos TCL
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisTCL"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisTesto')"
        >
          Arquivos Testo
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisTesto"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisTrane')"
        >
          Arquivos Trane
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisTrane"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>

        <button
          class="manualsCatalogs__tablinks"
          @click="openManual($event, 'manuaisVentisol')"
        >
          Arquivos Ventisol
        </button>
        <div
          class="manualsCatalogs__tabcontent"
          id="manuaisVentisol"
          style="overflow-x: auto"
        >
          <table>
            <thead>
              <tr>
                <th>Nome do Arquivo</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Visualizar Arquivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Manual</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
              <tr>
                <td>Teste</td>
                <td>Catálogo</td>
                <td>Carrier</td>
                <td><a href="">Visualizar</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    openManual(event, value) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName(
        "manualsCatalogs__tabcontent"
      );
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
        tabcontent[i].style.overflowX = "auto";
      }
      tablinks = document.getElementsByClassName("manualsCatalogs__tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(value).style.display = "block";
      event.currentTarget.className += " active";
    },
  },
};
</script>

<style lang="scss" scoped>
.catalogs {
  max-width: 95%;
  margin: 0 auto;

  @media (min-width: 441px) {
    max-width: 75%;
  }
}

.manualsCatalogs {
  h2 {
    color: var(--standardGreen);
    padding: 40px 0 20px 0;
    font-size: 1.3rem;
  }
  &__tab {
    display: flex;
    flex-direction: column;

    button {
      text-align: left;
      outline: none;
      background: var(--standardGreen);
      margin: 15px 0;
      padding: 10px;
      color: var(--customWhite);
      letter-spacing: 0.5px;

      &.active {
        background: var(--customDarkGreen);
      }
    }
  }

  &__tabcontent {
    display: none;
    background: var(--customWhite);
    padding: 10px;

    table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;

      thead {
        tr {
          th {
            text-align: center;
            color: var(--customGray-500);
            border-bottom: 1px solid var(--customGray-200);
            padding: 5px;
          }
        }
      }

      tbody {
        tr {
          &:hover {
            background: var(--customGray-100);
          }
          td {
            padding: 10px;
            border-bottom: 1px solid var(--customGray-100);
            color: var(--customGray-500);
            font-size: 0.95rem;
            text-align: center;

            a {
              background: var(--customBlue);
              border-radius: 5px;
              color: var(--customGray-800);
              text-decoration: none;
              padding: 5px;
            }
          }
        }
      }
    }
  }
}
</style>